import { render, staticRenderFns } from "./status.vue?vue&type=template&id=ff5e62c0&scoped=true&"
import script from "./status.vue?vue&type=script&lang=js&"
export * from "./status.vue?vue&type=script&lang=js&"
import style0 from "./status.vue?vue&type=style&index=0&id=ff5e62c0&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5e62c0",
  null
  
)

export default component.exports